// extracted by mini-css-extract-plugin
export var deleteIcon = "_og-5";
export var deleteOption = "_og-3";
export var divider = "_og-2";
export var downloadIcon = "_og-4";
export var drawer = "_og-0";
export var drawerFooter = "_og-6";
export var drawerOpen = "_og-1";
export var highlighted = "_og-7";
export var lighterHighlight = "_og-8";